"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAppSelector = exports.useAppDispatch = exports.persistor = exports.store = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var redux_persist_1 = require("redux-persist");
var storage_1 = __importDefault(require("redux-persist/lib/storage")); // defaults to localStorage for web
var auth_1 = require("../features/apis/auth");
var branches_1 = require("../features/apis/branches");
var loans_1 = require("../features/apis/loans");
var sites_1 = require("../features/apis/sites");
var uploads_1 = require("../features/apis/uploads");
var auth_2 = require("../features/slices/auth");
var content_dialog_1 = require("../features/slices/content-dialog");
var message_dialog_1 = require("../features/slices/message-dialog");
var site_1 = require("../features/slices/site");
var user_profile_1 = require("../features/slices/user-profile");
// Redux Persist configuration
var persistConfig = {
    key: "root",
    version: 1,
    storage: storage_1.default,
    // Only persist auth and userProfile slices (not API caches or dialogs)
    whitelist: ["auth", "userProfile"],
};
// Combine all reducers
var rootReducer = (0, toolkit_1.combineReducers)((_a = {
        auth: auth_2.authReducer,
        messageDialog: message_dialog_1.messageDialogReducer,
        contentDialog: content_dialog_1.contentDialogReducer,
        userProfile: user_profile_1.userProfileReducer,
        site: site_1.siteReducer
    },
    _a[auth_1.authApi.reducerPath] = auth_1.authApi.reducer,
    _a[branches_1.branchesApi.reducerPath] = branches_1.branchesApi.reducer,
    _a[sites_1.sitesApi.reducerPath] = sites_1.sitesApi.reducer,
    _a[uploads_1.uploadsApi.reducerPath] = uploads_1.uploadsApi.reducer,
    _a[loans_1.loansApi.reducerPath] = loans_1.loansApi.reducer,
    _a));
// Create persisted reducer
var persistedReducer = (0, redux_persist_1.persistReducer)(persistConfig, rootReducer);
exports.store = (0, toolkit_1.configureStore)({
    devTools: process.env.ENVIRONMENT !== "PROD",
    reducer: persistedReducer,
    middleware: function (getDefaultMiddleware) {
        return getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [
                    // Ignore redux-persist actions
                    redux_persist_1.FLUSH,
                    redux_persist_1.REHYDRATE,
                    redux_persist_1.PAUSE,
                    redux_persist_1.PERSIST,
                    redux_persist_1.PURGE,
                    redux_persist_1.REGISTER,
                    // Ignore RTK Query actions that contain non-serializable values (like FormData)
                    "uploadsApi/executeQuery/pending",
                    "uploadsApi/executeQuery/fulfilled",
                    "uploadsApi/executeMutation/pending",
                    "uploadsApi/executeMutation/fulfilled",
                    // Ignore Firebase profile payloads which may contain complex values before sanitization (defensive)
                    "userProfileSlice/setFirebaseUserProfile",
                ],
                ignoredPaths: ["userProfile.profile"],
            },
        }).concat([
            auth_1.authApi.middleware,
            branches_1.branchesApi.middleware,
            sites_1.sitesApi.middleware,
            uploads_1.uploadsApi.middleware,
            loans_1.loansApi.middleware,
        ]);
    },
});
exports.persistor = (0, redux_persist_1.persistStore)(exports.store);
// Export typed hooks for convenience
var hooks_1 = require("./hooks");
Object.defineProperty(exports, "useAppDispatch", { enumerable: true, get: function () { return hooks_1.useAppDispatch; } });
Object.defineProperty(exports, "useAppSelector", { enumerable: true, get: function () { return hooks_1.useAppSelector; } });
